import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { copyToClipboard } from '../helpers/index';
import { toastr } from 'react-redux-toastr';
import FailedTestArtifactsContainer from '../Containers/FailedTestArtifactsContainer';

const copyModalUrl = (url) => {
  copyToClipboard(url);
  return toastr.info('Copied Url');
};

const TestDetailsModalComponent = ({
  visible,
  onHide,
  runner,
  scenarioName,
  failedTestArtifacts,
  modalUrl
}) => {

  // enforceFocus = false fixes copy to clipboard issue that bootstrap modals have
  return (
    <Modal
      enforceFocus={false}
      show={visible}
      onHide={onHide}
      bsSize="lg"
      dialogClassName="large-modal"
    >
      {
        runner === undefined ?
          <Modal.Header closeButton>
            <Modal.Title>Error</Modal.Title>
          </Modal.Header> :
          <div>
            <Modal.Header closeButton>
              <Modal.Title>Test Artifacts for: <b>{scenarioName}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {
                failedTestArtifacts ?
                  Object.keys(failedTestArtifacts).map((testName) => {
                    return (
                      <FailedTestArtifactsContainer
                        key={testName}
                        test={testName}
                        consoleLog={failedTestArtifacts[testName].consoleLog}
                        crashLog={failedTestArtifacts[testName].crashLog}
                        imageB64={failedTestArtifacts[testName].image}
                        videoLink={failedTestArtifacts[testName].videoLink}
                        axiomLog={failedTestArtifacts[testName].axiomLog}
                        eventLog={failedTestArtifacts[testName].eventLog}
                        htmlLog={failedTestArtifacts[testName].htmlLog}
                      />
                    );
                  }) : <h3 key={-1}>No Tests Found.</h3>
              }
            </Modal.Body>
          </div>
      }

      <Modal.Footer>
        <Button id="copy-url-btn" onClick={() => copyModalUrl(modalUrl)}>
          Copy Test Artifacts URL
        </Button>
        <Button id="close-btn" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

TestDetailsModalComponent.propTypes = {
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func,
  runner: PropTypes.number,
  scenarioName: PropTypes.string,
  failedTestArtifacts: PropTypes.object,
  modalUrl: PropTypes.string.isRequired
};

export default TestDetailsModalComponent;


// WEBPACK FOOTER //
// src/Components/TestDetailsModalComponent.jsx